// Drawing utility functions.

'use strict';

// Draw a line on the given context from point `x1,y1` to point `x2,y2`.
function line(ctx, x1, y1, x2, y2) {
    ctx.beginPath();
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    ctx.stroke();
}

exports.line = line;



/*****************
 ** WEBPACK FOOTER
 ** ../opentype-fork/src/draw.js
 ** module id = 16
 ** module chunks = 0
 **/